import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
const TYPE = 'molten.dataViewer.dashboard.DataViewerCard';

// eslint-disable-next-line default-param-last
function create(dataViewer = null, props) {
  return {
    id: v4(),
    type: TYPE,
    height: null,
    minHeight: null,
    maxHeight: null,
    dataViewer,
    ...props
  };
}
const access = {
  ...ModelUtil.createAllValue('minHeight'),
  ...ModelUtil.createAllValue('height'),
  ...ModelUtil.createAllValue('maxHeight'),
  ...ModelUtil.createAllValue('needsDate', null, null, {
    defaultValue: false
  }),
  ...ModelUtil.createAllValue('needsCondition', null, null, {
    defaultValue: false
  }),
  ...ModelUtil.createAllValue('needsOrder', null, null, {
    defaultValue: false
  }),
  ...ModelUtil.createAllValue('dataViewer'),
  ...ModelUtil.createAllValue('dataViewer/type', 'dataViewerType'),
  ...ModelUtil.createAllValue('dataViewer/settings', 'dataViewerSettings')
};
export default {
  TYPE,
  create,
  ...access,
  getDataViewerId(model) {
    return model?.dataViewer?.id;
  },
  getId: model => {
    return model.id;
  },
  getSettingsPath: model => {
    return `${model.type}.${model.id}`;
  },
  getRequired: (m, f, dc) => {
    const needsOrder = access.getNeedsOrder(m);
    const needsCondition = access.getNeedsCondition(m);
    const needsDate = access.getNeedsDate(m);
    if (needsDate || needsOrder || needsCondition) {
      const needs = [];
      if (needsOrder) {
        needs.push('order');
      }
      if (needsCondition) {
        needs.push('condition');
      }
      if (needsDate) {
        needs.push('dateTimeRange');
      }
      return needs;
    }
    return null;
  }
};